import React from 'react';
import { Helmet } from 'react-helmet';
import LandingWizard from '../components/landing/LandingWizard';
import { landingConfig } from '../components/landing/landingConfig';

export default function Ajanlat() {
  return (
    <>
      {landingConfig.seo && (
        <Helmet>
          <title>{landingConfig.seo.title}</title>
          <meta name="description" content={landingConfig.seo.description} />
          <meta name="robots" content="noindex, follow" />
        </Helmet>
      )}
      <LandingWizard config={landingConfig} />
    </>
  );
}
